import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import ContractDetails from "../../components/Contract/ContractDetails";


const ContractShow = ({contract, files}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('contract.self.details')}
            items={[
                {
                    icon: 'arrow_back_ios',
                    text: i18n.get('default.nav.back'),
                    href: '/contract',
                    color: 'secondary',
                    size: 'small',
                },
                /*{
                    icon: 'history',
                    text: i18n.get('project.history.button'),
                    href: `/contract/${project.id}/history`,
                    size: 'small',
                },*/
                {
                    icon: 'edit',
                    text: i18n.get('project.edit'),
                    href: `/contract/${contract.id}/edit`,
                    size: 'small',
                }
            ]}
        />

        <ContractDetails contract={contract} files={files} />

    </Layout>
);

export default ContractShow;
